import ColorThief, { ArrayRGB } from 'colorthief/dist/color-thief.umd.js';

const rgbToHex = (colors: ArrayRGB) =>
  `#${colors
    .map((value: number) => {
      const hex = value.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    })
    .join('')}`;

export const useColorThief = (crossOrigin: string) => {
  const cf = new ColorThief();

  const loadImage = (url: string, crossOrigin: string | null) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.addEventListener('load', () => {
        resolve(img);
      });
      img.addEventListener('error', () => {
        reject(new Error(`Failed to load image URL: ${url}`));
      });
      img.crossOrigin = crossOrigin;
      img.src = url;
    });

  const getColor = async (imgUrl: string, quality: number) => {
    const img = (await loadImage(imgUrl, crossOrigin)) as HTMLImageElement;
    const arrayRGB = cf.getColor(img, quality);
    return rgbToHex(arrayRGB);
  };

  const getPalette = async (
    imgUrl: string,
    colorCount: number,
    quality: number,
  ) => {
    const img = (await loadImage(imgUrl, crossOrigin)) as HTMLImageElement;
    const arrayRGB = cf.getPalette(img, colorCount, quality);
    return arrayRGB.map((colors: ArrayRGB) => {
      return rgbToHex(colors);
    });
  };

  return {
    getColor,
    getPalette,
  };
};
